<template>
  <module-page v-bind="pageParams" :customBreadcrumbs="breadcrumbs">
    <v-layout row wrap>
      <v-flex xs12 md8 lg8>
        <v-card class="mt-2 mb-5 mr-3">
          <v-card-title
            v-if="cardTitle"
            class="topic__title support--color pt-2"
            >{{ cardTitle }}</v-card-title
          >
          <v-card-text class="topic__body">
            <screen-loading v-if="loading"></screen-loading>
            <v-layout v-else row wrap>
              <title-message-card :items="currentMessage"></title-message-card>
              <schedule-field
                required
                @scheduleSelected="onSelect"
                @changeDate="changeDate"
                :date="date"
                :datePicker="individualSchedule"
                :datePickerAllowedDates="allowedDates"
                :datePickerMinDate="minDate"
                :datePickerMaxDate="maxDate"
                :dateSelectItems="dates"
                :loadingSchedule="loadingSchedule"
                :schedule="eventSchedule"
                :isScheduleSelected="v => v.date === selectedDate"
                :getScheduleLabel="getLabel"
                :emptyState="emptyState"
                v-if="!mySchedule._id"
                selectedClass="support--background white--text"
              ></schedule-field>
              <v-flex
                v-if="showReSchedule"
                xs12
                :class="
                  `mt-3 ${mySchedule._id ? 'center--text' : 'support--color'}`
                "
                >{{
                  mySchedule._id || individualSchedule
                    ? ''
                    : $t('labels.scheduleWarning')
                }}</v-flex
              >
              <v-flex xs12 :md2="!mySchedule._id" class="mt-3 mb-3">
                <v-btn v-if="individualSchedule" @click="goToEventSchedule">{{
                  $t('actions.goBack')
                }}</v-btn>
                <v-btn
                  v-else-if="hasIndividualSchedule && showReSchedule"
                  @click="goToIndividualSchedule"
                  :style="mySchedule._id ? { margin: '0 39%' } : ''"
                  class="support--background white--text"
                  >{{ $t('labels.selectOtherDate') }}</v-btn
                >
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex v-if="!mySchedule._id" xs12 md2 class="mt-3 pb-3">
                <v-btn
                  :disabled="!selected"
                  @click="submit"
                  class="success--background white--text"
                >
                  <v-progress-circular
                    color="white"
                    indeterminate
                    v-if="loadingForm"
                  ></v-progress-circular>
                  <span v-else>{{ $t('actions.confirm') }}</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 lg4 class="mt-4 mb-4">
        <faq-card
          :items="faqItems"
          :loading="faqLoading"
          :error="faqError"
          :params="faqCardParams"
          :errorText="$t('responses.error')"
          @faqSelected="goToFaq"
          :retryFunction="getFaqs"
        ></faq-card>
      </v-flex>
    </v-layout>
    <modal
      persistent
      :width="modalWidth"
      v-model="modal"
      :title="modalTitle"
      :titleClass="modalTitleClass"
      :content="modalContent"
      @close="onModalClosed"
    >
      <template slot="customActions">
        <v-layout row wrap>
          <v-flex xs12>
            <v-checkbox
              v-if="termsModal"
              v-model="termsAgreed"
              :label="$t('labels.termsAgreed')"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 md6 lg6>
            <v-btn
              :class="mobile ? 'mb-5' : ''"
              v-if="individualScheduleModal"
              :disabled="loading || loadingSchedule"
              @click="goToEventSchedule"
              >{{ $t('actions.goBack') }}</v-btn
            >
          </v-flex>
          <v-spacer />
          <v-flex
            xs12
            md2
            lg2
            :class="!mobile && !individualScheduleModal ? 'pt-3 pl-4' : ''"
          >
            <v-btn
              :disabled="termsModal && !termsAgreed"
              @click="modal = false"
              class="success--background white--text"
              >{{ modalSubmitLabel }}</v-btn
            >
          </v-flex>
        </v-layout>
      </template>
    </modal>
  </module-page>
</template>

<script>
import moment from 'moment-timezone';
import { contractIsActive, getUnitProposersInfo } from '@/utils';
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import faqMixin from '@/mixins/modules/faq';
import supportMixin from '@/mixins/modules/support';
import eventsMixin from '@/mixins/modules/events';
import ModulePage from '@/components/layout/Page';
import FaqCard from '@/components/modules/FaqCard';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import TitleMessageCard from '@/components/layout/TitleMessageCard';
import Modal from '@/components/layout/Modal';
import ScheduleField from '@/components/fields/Schedule';
import {
  APP,
  CONFIG,
  EVENTS,
  EVENT_TYPES,
  EVENT_TYPES_BY_ID
} from '../../../utils/constants';

export default {
  name: 'keyDeliverySchedule',
  mixins: [faqMixin, supportMixin, eventsMixin],
  components: {
    ModulePage,
    FaqCard,
    ScreenLoading,
    ScheduleField,
    Modal,
    TitleMessageCard
  },
  computed: {
    keyDeliveryTerms() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .keyDeliveryTerms;
    },
    individualScheduleTerms() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .individualScheduleTerms;
    },
    keyDeliveryReScheduleTerms() {
      return (this.$store.getters[CONFIG.GET] || { texts: {} }).texts
        .keyDeliveryReScheduleTerms;
    },
    selectedDate() {
      return (this.selected || {}).date;
    },
    emptyState() {
      return (
        (!this.eventSchedule.length && this.$t('labels.selectDateDesc')) ||
        (!this.hasAvailableSchedule && this.$t('labels.noAvailableSchedule'))
      );
    }
  },
  data() {
    return {
      modal: false,
      termsModal: false,
      loadingForm: false,
      individualScheduleModal: false,
      modalTitle: '',
      modalContent: '',
      eventId: '',
      currentMessage: [],
      modalWidth: '',
      modalTitleClass: '',
      modalSubmitLabel: '',
      cardTitle: '',
      breadcrumbs: [
        {
          text: this.$t('labels.schedule')
        }
      ],
      loading: false,
      loadingSchedule: false,
      hasAvailableSchedule: false,
      mySchedule: {},
      event: {},
      eventSchedule: [],
      dates: [],
      date: '',
      hasIndividualSchedule: true,
      termsAgreed: false,
      selected: null,
      individualSchedule: false,
      blockedDates: [],
      minDate: moment()
        .add(1, 'day')
        .format('YYYY-MM-DD'),
      maxDate: null,
      pageParams: this.$store.getters[APP.PAGES].keyDeliverySchedule,
      faqCardParams: this.$store.getters[APP.APP_MODULES].faq,
      showReSchedule: true,
      previousScheduleId: null
    };
  },
  created() {
    bus.$on('unit:change', this.redirectToHome);
    bus.$on('unit:update', this.getMySchedule);

    this.getFaqs();
    this.getMySchedule();
  },
  beforeDestroy() {
    bus.$off('unit:change', this.redirectToHome);
    bus.$off('unit:update', this.getMySchedule);
  },
  methods: {
    redirectToHome() {
      this.$router.push({ name: 'home' });
    },

    async getMySchedule(unitObj = null) {
      try {
        this.loading = true;
        const today = this.toDefaultTimezone()
          .startOf('day')
          .format('YYYY-MM-DD');
        if (
          !this.$store.getters[EVENTS.GET_KEYDELIVERY] ||
          !this.$store.getters[EVENTS.GET_KEYDELIVERY].periods
        ) {
          await this.getEvent([EVENT_TYPES_BY_ID[EVENT_TYPES.keyDelivery]]);
        }
        const keyDeliveryEvent = this.$store.getters[EVENTS.GET_KEYDELIVERY];
        if (!keyDeliveryEvent) {
          bus.$emit('snackbar:open', {
            text: this.$t('responses.invalidEventError'),
            color: enums.snackbarColors.error
          });
          return this.$router.push({ name: 'home' });
        }
        this.keyDeliveryEventId = keyDeliveryEvent._id;

        const usernames = getUnitProposersInfo(this.selectedUnit, 'document');

        const params = {
          usernames,
          sku: this.selectedUnit.sku
        };
        const url = `${process.env.SCHEDULE_API_URL}/event/${this.keyDeliveryEventId}`;
        const data = await this.requestService(url, 'GET', {
          params
        });

        if (!data) return;

        this.mySchedule = data[0] || {};

        // ? Verifications for individual schedule redirection
        if (!this.mySchedule._id) {
          // ? The client did not scheduled before
          if (!keyDeliveryEvent.periods.find(period => period.date > today)) {
            return this.goToIndividualSchedule();
          } else if (
            keyDeliveryEvent.exhibitionEndDate &&
            keyDeliveryEvent.exhibitionEndDate < today &&
            this.mySchedule.type != 'Individual'
          ) {
            // ? The mutual event exhibition has due
            return this.goToIndividualSchedule();
          }
        } else if (this.mySchedule.date < today) {
          // ? The schedule has due
          return this.goToIndividualSchedule();
        }

        if (!this.mySchedule._id && !!this.keyDeliveryTerms) {
          this.cardTitle = '';
          this.modalTitleClass = '';
          this.modalTitle = this.$t('labels.keyDeliveryTermsTitle');
          this.modalContent = this.keyDeliveryTerms;
          this.modalWidth = '800';
          this.modalSubmitLabel = this.$t('actions.accept');
          this.individualScheduleModal = false;
          this.modal = this.termsModal = true;
          this.termsAgreed = false;
          return this.getMainEvent(unitObj);
        }

        this.cardTitle = this.$t('labels.keyDeliveryScheduled');

        this.currentMessage = [
          {
            titleClass: 'support--color bold--text',
            title: `${this.$t('labels.datetime')}:`,
            message: this.formatLongDateTime(this.mySchedule.date)
          },
          {
            titleClass: 'support--color bold--text',
            title: this.$t('labels.eventAddress'),
            message: this.mySchedule.address
          }
        ];
      } catch (err) {
        console.error(err);
        bus.$emit('snackbar:open', {
          text: this.$t('responses.error'),
          color: enums.snackbarColors.error
        });
      } finally {
        this.loading = false;
      }
    },
    async getMainEvent(unitObj = null, useLoadingSchedule = false) {
      try {
        if (useLoadingSchedule) {
          this.loadingSchedule = true;
        } else {
          this.loading = true;
        }

        if (!this.individualSchedule) {
          const url = `${process.env.EVENT_API_URL}/${this.keyDeliveryEventId}`;
          const data = await this.requestService(url, 'GET', {
            params: {
              username: this.user.username
            }
          });

          this.event = data;

          this.$store.commit(EVENTS.UPDATE_KEYDELIVERY, data);

          this.formatDates(this.event.periods, unitObj);
        } else {
          const date = this.date || moment().format('YYYY-MM-DD');
          const url = `${process.env.EVENT_API_URL}/individualSchedule/${date}/${this.keyDeliveryEventId}`;
          const data = await this.requestService(url, 'GET', {
            localErrorHandling: true,
            params: {
              username: this.user.username
            }
          });
          this.event = {
            _id: data.id,
            address: data.address
          };

          this.eventSchedule = data.availableTimes;
          this.hasAvailableSchedule = this.eventSchedule.find(o => o.available);
          this.blockedDates = data.blockedDates;
          this.minDate = data.minScheduleDate;
          this.maxDate = data.maxScheduleDate;

          if (!this.allowedDates(this.date)) {
            this.changeDate(this.minDate);
          }

          if (moment(this.date).isAfter(this.maxDate)) {
            this.changeDate(this.maxDate);
          }

          if (moment(this.date).isBefore(this.minDate)) {
            this.changeDate(this.minDate);
          }
        }

        this.currentMessage = [
          {
            titleClass: 'support--color bold--text',
            title: this.$t('labels.eventAddress'),
            message: this.event.address
          }
        ];
      } catch (err) {
        if (this.individualSchedule) {
          this.hasIndividualSchedule = false;
        }

        bus.$emit('snackbar:open', {
          text: this.$t('responses.error'),
          color: enums.snackbarColors.error
        });
      } finally {
        if (useLoadingSchedule) {
          this.loadingSchedule = false;
        }
        this.loading = false;
      }
    },
    async getSchedule(unitObj = null) {
      try {
        this.loadingSchedule = true;
        const data = {
          username: this.user.username,
          dates: [this.date]
        };
        const url = `${process.env.EVENT_API_URL}/${this.keyDeliveryEventId}/schedule`;
        const res = await this.requestService(url, 'POST', {
          data
        });

        this.eventSchedule = res;

        this.hasAvailableSchedule = this.eventSchedule.find(o => o.available);
      } catch (err) {
        bus.$emit('snackbar:open', {
          text: this.$t('responses.error'),
          color: enums.snackbarColors.error
        });
      } finally {
        this.loadingSchedule = false;
      }
    },
    async submit() {
      if (this.loadingForm) return;

      let log = {};
      log['message'] = [];

      try {
        log.message.push('Start');
        if (!this.selected) return;

        this.loadingForm = true;

        log.message.push('selectedUnit.contracts');
        const contractId = this.selectedUnit.contracts.find(contractIsActive)
          .id;
        const body = {
          date: this.selected.date,
          periodId: this.selected.periodId,
          eventId: this.selected.eventId,
          username: this.user.username,
          contractId,
          ...(this.individualSchedule
            ? {
                targetEventId: this.keyDeliveryEventId
              }
            : {})
        };

        log['bodyLog'] = body;

        if (this.previousScheduleId) {
          log.message.push('previousScheduleId - true');
          body._id = this.previousScheduleId;
        }

        log.message.push('requestService - start');
        const { message, data: resultScheduleId } = await this.requestService(
          process.env.SCHEDULE_API_URL,
          'POST',
          {
            data: body
          }
        );

        log.message.push('requestService - end');

        console.log(message, resultScheduleId);

        log['requestServiceMessageLog'] = { message, resultScheduleId };

        if (message) {
          log.message.push('getTicketContent');

          const content = this.getTicketContent();

          log['contentGetTicketContent'] = content;

          const attachments = [];
          const payload = {
            summary: `${'Agendamento de entrega de chaves'}`,
            comments: {
              public: { content, attachments }
            },
            currentStatusName: 'Resolvido'
          };

          log['payload'] = payload;

          log.message.push('sendTicket - start');
          let valueRequest = await this.sendTicket(payload);
          log.message.push('sendTicket - end');

          log['RequestSendTicketValue'] = valueRequest;

          bus.$emit('snackbar:open', {
            text: message,
            color: enums.snackbarColors.success
          });

          const action =
            enums.logTraceActions[
              `keyDelivery${
                this.previousScheduleId ? 'Reschedule' : 'Schedule'
              }`
            ];

          log['action'] = action;

          const details = {
            date: body.date,
            ...(!this.previousScheduleId
              ? {
                  type: this.individualSchedule ? 'Individual' : 'Massa',
                  termsAgreed: this.termsAgreed
                }
              : {})
          };

          log['details'] = details;

          log.message.push('SMS - start');

          //SMS
          const shippingScale = this.individualSchedule ? 'single' : 'mutual';
          const shippingMode = this.previousScheduleId
            ? 'ReScheduled'
            : 'Scheduled';
          const smsUrl = `${process.env.SMS_API}/addToQueue`;
          const smsType = `${shippingScale}KeyDelivery${shippingMode}`;
          const smsData = {
            contractId,
            productId: this.selectedUnit.product.id,
            blockCode: this.selectedUnit.block.code,
            unitCode: this.selectedUnit.unit.code,
            smsType,
            scheduleId: resultScheduleId
          };

          log['smsData'] = smsData;
          log['smsUrl'] = smsUrl;

          this.requestService(smsUrl, 'POST', {
            data: smsData
          });

          log.message.push('SMS - end');

          log.message.push('createTrace - start');

          log['createTraceAction'] = action;
          log['createTraceDetails'] = details;
          this.createTrace(action, details);

          log.message.push('createTrace - end');

          log['individualSchedule'] = this.individualSchedule;

          if (this.individualSchedule) {
            this.goToEventSchedule();
          } else {
            this.showReSchedule = false;
            this.getMySchedule();
          }

          this.createTrace(enums.logTraceActions.controlledLogInfo, {
            Information: {
              log,
              date: moment(),
              description: 'KeyDeliverySchedule - Completed - submit'
            }
          });
        }
      } catch (error) {
        this.createTrace(enums.logTraceActions.controlledLogError, {
          Errors: {
            error,
            date: moment(),
            description: 'KeyDeliverySchedule - catch - submit',
            log
          }
        });

        bus.$emit('snackbar:open', {
          text: this.$t('responses.error'),
          color: enums.snackbarColors.error
        });
      } finally {
        this.loadingForm = false;
      }
    },
    getTicketContent() {
      const terms = this.modalContent;
      const date = this.formatLongDateTime(this.selectedDate);
      const address = this.event.address;
      return `Data da entrega de chaves:\n${date}\nEndereço:\n${address}\n.\n. \n${terms}`;
    },
    async getProductLocationState({ code, id }) {
      const params = {
        filter: { code, externalSourceId: id },
        desiredFields: { code: 1, address: 1 }
      };
      const url = `${process.env.CRUD_API_GET}/product`;
      const result = await this.requestService(url, 'GET', {
        params
      });
      const [item] = result.items;

      if (!item || !item.address) {
        throw new Error(
          `This product does not exist on database. PRODUCT_CODE: ${code}`
        );
      }

      return item.address.uf;
    },
    formatDates(periods, unitObj) {
      this.dates = [];
      let lastDate = null;

      for (let { date } of periods) {
        const defaultTimezoneDate = this.toDefaultTimezone(date);

        if (lastDate && lastDate.isSame(defaultTimezoneDate)) continue;

        this.dates.push({
          text: defaultTimezoneDate.format('DD/MM/YYYY'),
          value: defaultTimezoneDate.format('YYYY-MM-DD')
        });

        lastDate = moment(date);
      }

      if (this.dates.length === 1) {
        this.date = this.dates[0].value;

        this.getSchedule(unitObj);
      }
    },
    getLabel({ date }) {
      return this.toDefaultTimezone(date).format('HH:mm');
    },
    onSelect(schedule) {
      if (!schedule.available) return;

      if (schedule.date === this.selectedDate) {
        this.selected = null;
        return;
      }

      this.selected = schedule;
    },
    onModalClosed() {
      this.termsModal && this.$router.push({ name: 'home' });

      this.modal = this.termsModal = this.individualScheduleModal = false;
    },
    goToEventSchedule() {
      this.modal = false;
      this.individualSchedule = false;
      this.date = '';
      this.time = null;
      this.schedule = [];

      this.getMySchedule();
    },
    goToIndividualSchedule() {
      this.individualSchedule = true;
      this.time = null;
      this.schedule = [];
      this.date = this.minDate;

      if (this.mySchedule._id) this.previousScheduleId = this.mySchedule._id;

      const keyDeliveryEvent = this.$store.getters[EVENTS.GET_KEYDELIVERY];
      const today = moment()
        .startOf('day')
        .format('YYYY-MM-DD');
      if (
        this.mySchedule.date < today ||
        (keyDeliveryEvent.exhibitionEndDate &&
          keyDeliveryEvent.exhibitionEndDate < today)
      ) {
        this.modalContent = this.individualScheduleTerms;
      } else {
        this.modalContent =
          this.keyDeliveryReScheduleTerms || this.individualScheduleTerms;
      }
      this.mySchedule = {};

      this.modalTitle = this.$t('labels.attention');
      this.modalWidth = '600';
      this.modalTitleClass = 'error--color';
      this.modalSubmitLabel = this.$t('labels.procede');
      this.termsModal = true;
      this.termsAgreed = false;
      this.modal = this.individualScheduleModal = true;

      this.getMainEvent().then(() => {
        this.schedule = [];
      });
    },
    changeDate(v) {
      if (!this.allowedDates(v, false)) {
        const method = moment(v).isSameOrAfter(this.date) ? 'add' : 'subtract';

        return this.changeDate(
          moment(v)
            [method](1, 'days')
            .utc()
            .format('YYYY-MM-DD')
        );
      }

      this.date = v;

      this.individualSchedule
        ? this.getMainEvent(null, true)
        : this.getSchedule();
    },
    allowedDates(v, validate = true) {
      if (validate && (!this.event._id || this.loading)) return false;

      return !this.blockedDates.find(o =>
        moment(v).isSame(
          moment(o)
            .utc()
            .format('YYYY-MM-DD')
        )
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// ./src/views/support/schedule/KeyDeliverySchedule.vue